import React from 'react'
import styled from 'styled-components';
import PropTypes from 'prop-types'

const TableStyle = styled.table`
  border-collapse: collapse;
  width: 100%;
  color: #142A3F;
  font-size: 16px;
  td, th {
    border: 1px solid #C3CDD8;
    padding: 8px 20px;
    width: ${({col})=> {
      return (100/col)+'%';
    }}
  }
  tr:hover {background-color: #eee;}
  th {
    padding-top: 12px;
    padding-bottom: 12px;
    font-weight: 500;
  }
  @media (max-width: 768px) {
    td, th {
      text-align: center;
      padding: 5px 0;
      vertical-align: middle;
    }
  }
`;

export default function DocTable(props) {
  const tablebodys = props.bodys.map((v, i) => {
    const tds = v.map((vv, ii)=> {
      return <td key={ii}>{vv}</td>
    })
    return <tr key={i}>{tds}</tr>
  })
  return (
    <TableStyle col={props.col}>
      <thead>
        <tr>
        {props.titles && props.titles.map((v, i)=><th key={i}>{v}</th>)}
        </tr>
      </thead>
      <tbody>
      {tablebodys}
      </tbody>     
    </TableStyle>
  )
}
DocTable.propTypes = {
  titles: PropTypes.array,
  bodys: PropTypes.array.isRequired,
  col: PropTypes.number.isRequired,
}

